import { GroupByDate } from '@/models/app-common/app-common.model';

export enum ReportListFilterFields {
  GROUP_BY_DATE = 'groupByDate',
  COUNTRY = 'country',
  CURRENCY = 'currency',
  GAME_PRODUCER_ID = 'gameProducerId',
  GAME_TYPE = 'gameType',
  GAME_CATEGORY = 'gameCategory',
  DATE_FROM = 'dateFrom',
  DATE_TO = 'dateTo',
  EXCHANGE_RATE_DATE = 'exchangeRateDate',
}

export const DEFAULT_FILTER_FORM_DATA: ReportListFilter = {
  [ReportListFilterFields.GROUP_BY_DATE]: GroupByDate.MONTH,
} as const;

export type ReportListFilter = {
  [ReportListFilterFields.GROUP_BY_DATE]: GroupByDate;
  [ReportListFilterFields.COUNTRY]?: string;
  [ReportListFilterFields.CURRENCY]?: string;
  [ReportListFilterFields.GAME_PRODUCER_ID]?: string;
  [ReportListFilterFields.GAME_TYPE]?: string;
  [ReportListFilterFields.GAME_CATEGORY]?: string;
  [ReportListFilterFields.DATE_FROM]?: string;
  [ReportListFilterFields.DATE_TO]?: string;
  [ReportListFilterFields.EXCHANGE_RATE_DATE]?: string;
}
